module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-11.svg?6a87f78543c2d4fecedf218ed76331b7";